import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { symbolWinResultDisplay } from "./scatter-result-display";

export function clusterResultDisplay(record: Record, result: Result) {
    return symbolWinResultDisplay(record, result);
}
